/* eslint react-hooks/exhaustive-deps: "warn" */


import { useRouter } from 'next/router';

import { Button } from 'ui/atoms/Button/Button';
import { AnimatedDotsBackground } from 'ui/atoms/AnimatedDotsBackground/AnimatedDotsBackground';
import type { FeatureGridItem } from 'ui/atoms/FeatureGrid/FeatureGrid';
import { HeroSection } from 'ui/molecules/HeroSection/HeroSection';
import { StatsBlock } from 'ui/molecules/StatsBlock/StatsBlock';

import styles from './McpHeroSection.module.scss';

const FEATURE_ITEMS: FeatureGridItem[] = [
  {
    value: '600',
    suffix: 'M+',
    title: 'Companies'.toUpperCase(),
  },
  {
    value: '400',
    suffix: '+',
    title: 'Gov. Registries'.toUpperCase(),
  },
  {
    value: '200',
    suffix: '+',
    title: 'Countries'.toUpperCase(),
  },
  {
    value: '43',
    suffix: 'M',
    title: 'Corporate Linkages'.toUpperCase(),
  },
  {
    value: '100',
    suffix: '%',
    title: 'Source-Cited'.toUpperCase(),
  },
];

export const McpHeroSection = () => {
  const { asPath } = useRouter();

  return (
    <div className={styles.container}>
      <HeroSection
        title="MCP, meet company data."
        descriptionClassName={styles.descriptionFullWidth}
        description={
          <span>
            The Global Database MCP server gives Claude, ChatGPT, Gemini and your own agents live access to KYB,
            ownership and financial data — collected directly from 400+ official government registries across 200+
            countries.
          </span>
        }
        extra={
          <div className={styles.extra}>
            <div className={styles.actions}>
              <AnimatedDotsBackground
                className={styles.actionsAnimation}
                lines={2}
                opacity={0.6}
                offsetY={-15}
                gap={120}
              />

              <Button
                size="xxl"
                type="dark"
                href={`https://platform.globaldatabase.com/public/signup/mcp?origin=${process.env.HOST}${asPath}`}
              >
                Get Started Free
              </Button>
            </div>
          </div>
        }
        media={<StatsBlock hasPadding={false} hasBackground={false} features={FEATURE_ITEMS} />}
        mediaPosition="bottom"
      />
    </div>
  );
};
